import { axiosAccountPrivateV2 } from "../../../../api/axios";
import { SUBSYSTEMS_HEADER } from "../../../../api/constants";
import {
  RequestApiGticket,
  RequestApiPrivateGTicketV2,
  RequestApiPrivateGticket,
} from "../../../gticket/api/axios";
import {
  RequestApiPrivateQuickTicket,
  RequestApiPrivateQuickTicketAdmin,
  RequestApiUsers,
} from "../../api/axios";

export const getListServicesAPI = async (params: any) => {
  try {
    const res = await RequestApiPrivateQuickTicketAdmin.get("/services", {
      params: params,
    });
    return res.data;
  } catch (error: any) {
    if (error) {
      return error.code;
    }
  }
};

export const getDetailServicesAPI = async (id: any, params: any = {}) => {
  try {
    const res = await RequestApiPrivateQuickTicket.get(
      `/services/detail/${id || ""}`,
      {
        params: params,
      }
    );
    return res.data;
  } catch (error: any) {
    if (error) {
      return error.code;
    }
  }
};

export const getListSoftwareAPI = async (params: any) => {
  try {
    const res = await RequestApiPrivateQuickTicketAdmin.get("/softwares", {
      params: params,
    });
    return res.data;
  } catch (error: any) {
    if (error) {
      return error.code;
    }
  }
};

export const getListHardwareAPI = async (params: any) => {
  try {
    const res = await RequestApiPrivateQuickTicketAdmin.get("/hardwares", {
      params: params,
    });
    return res.data;
  } catch (error: any) {
    if (error) {
      return error.code;
    }
  }
};

export const createServiceAPI = async (body: any) => {
  try {
    const res = await RequestApiPrivateQuickTicketAdmin.post("/services", body);
    return res.data;
  } catch (error: any) {
    if (error) {
      return error.response?.data;
    }
  }
};

export const editServiceAPI = async (id: any, body: any) => {
  try {
    const res = await RequestApiPrivateQuickTicketAdmin.put(
      `/services/${id || ""}`,
      body
    );
    return res.data;
  } catch (error: any) {
    if (error) {
      return error.response?.data;
    }
  }
};

export const getSLATypeAPI = async () => {
  try {
    const res = await RequestApiUsers.get("/sla-types", {
      headers: SUBSYSTEMS_HEADER.QUICK_TICKET,
    });
    return res.data;
  } catch (error: any) {
    if (error) {
      return error.code;
    }
  }
};

export const getListAssigneeAPI = async (params: any = {}) => {
  try {
    const res = await RequestApiUsers.get("/user-teams", {
      params,
      headers: SUBSYSTEMS_HEADER.QUICK_TICKET,
    });
    return res.data;
  } catch (error: any) {
    if (error) {
      return error.code;
    }
  }
};

export const getListRegionAPI = async (params: any = {}) => {
  try {
    const res = await axiosAccountPrivateV2.get("/workspaces/get-by-filters", {
      params: { parent_ids: [1], ...params },
      headers: SUBSYSTEMS_HEADER.QUICK_TICKET,
    });
    return res.data;
  } catch (error: any) {
    if (error) {
      return error.code;
    }
  }
};

export const getListDepartmentAPI = async (params: any) => {
  try {
    const res = await RequestApiUsers.get("/department", {
      params: params,
      headers: SUBSYSTEMS_HEADER.QUICK_TICKET,
    });
    return res.data;
  } catch (error: any) {
    if (error) {
      return error.code;
    }
  }
};

export const exportServicesDataAPI = async (params: any) => {
  try {
    const response = await RequestApiPrivateQuickTicketAdmin.get(
      "/services/export",
      {
        params: params,
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getListCategoryAPI = async (body: any) => {
  try {
    const res = await RequestApiGticket.post("/categories/list", body, {
      headers: SUBSYSTEMS_HEADER.QUICK_TICKET,
    });
    return res.data;
  } catch (error: any) {
    if (error) {
      return error.code;
    }
  }
};

export const getListCategoryAPIV2 = async (body: any) => {
  try {
    const res = await RequestApiPrivateGTicketV2.post(
      "/categories/list",
      body,
      {
        headers: SUBSYSTEMS_HEADER.QUICK_TICKET,
      }
    );
    return res.data;
  } catch (error: any) {
    if (error) {
      return error.code;
    }
  }
};

export const getDetailCategoryAPI = async (id: any, params: any = {}) => {
  try {
    const res = await RequestApiPrivateGticket.get(`/categories/show/${id}`, {
      ...params,
      headers: SUBSYSTEMS_HEADER.QUICK_TICKET,
    });
    return res.data;
  } catch (error: any) {
    if (error) {
      return error.code;
    }
  }
};
